// extracted by mini-css-extract-plugin
export default {"form":"edit-key-dialog_form__wQvjN","group":"edit-key-dialog_group__1jFGJ","select":"edit-key-dialog_select__mxp65","input":"edit-key-dialog_input__VCMtm"};